import '../../assets/components/ProductNutritionTab/productNutritionTab.css';const t = "_accordionContent_urug2_1", o = "_destyleList_urug2_22", e = {
  accordionContent: t,
  destyleList: o
};
export {
  t as accordionContent,
  e as default,
  o as destyleList
};
